import { messagesNow } from '@/i18n'
import { messages } from './messages'

// Ported 1:1 from oa-studio-prototype `src/components/editor/blocks/BlockEditor.tsx`
// (countWords/wordsOk/wordNoun, lines 40–50) — the mechanics behind quiz
// word-count limits and their counters.

/** Trim + split on whitespace; counts words in a (possibly empty/null) string. */
export const countWords = (value?: string | null): number => {
  const trimmed = (value ?? '').trim()
  return trimmed ? trimmed.split(/\s+/).length : 0
}

/**
 * Allow an edit when it is within the word limit OR when it REDUCES the word
 * count relative to `prev`. Without the second clause an over-long
 * AI-generated answer becomes uneditable — you could never shorten it back
 * under the cap, since every intermediate keystroke would still count too
 * many words.
 */
export const wordsOk = (next: string, max: number, prev?: string | null): boolean => {
  // Пробел после слова, добивающего лимит, не пускаем: на бэк он уйдёт обрезанным,
  // а в поле остался бы невидимый хвост. Стирание (строка не длиннее prev) разрешено всегда.
  const growsTrailingSpace =
    countWords(next) >= max && /\s$/.test(next) && next.length > (prev ?? '').length
  return (countWords(next) <= max || countWords(next) < countWords(prev)) && !growsTrailingSpace
}

/**
 * Same shape as `wordsOk` but for a plain character cap: allow the edit when
 * it's within `max` OR when it does not LENGTHEN the string relative to `prev`
 * (equal length is allowed).
 * Controlled character-capped fields are otherwise stuck once a value already
 * exceeds a cap that was tightened after the value was saved (backend limit
 * lowered 2026-07-27) — every keystroke, including Backspace, gets reverted
 * because the guard is a bare `next.length > max` return.
 */
export const charsOk = (next: string, max: number, prev?: string | null): boolean =>
  next.length <= max || next.length <= (prev ?? '').length

/** «слово»/«word» for a count/limit `n`, on the UI language. */
export const wordNoun = (n: number): string => messagesNow(messages).wordNoun(n)
